if (!customElements.get('lamp-accessories-selector')) {
  customElements.define(
    'lamp-accessories-selector',
    class LampAccessoriesSelector extends HTMLElement {
      constructor() {
        super();

        this.selects = Array.from(this.querySelectorAll('[data-lamp-accessories-select]'));
        this.button = this.querySelector('[data-lamp-accessories-add]');
        this.status = this.querySelector('[data-lamp-accessories-status]');
        this.spinner = this.querySelector('.loading__spinner');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.selects.forEach((select) => select.addEventListener('change', this.updateButtonState.bind(this)));
        this.button.addEventListener('click', this.onAddClick.bind(this));
        this.updateButtonState();
      }

      updateButtonState() {
        const hasSelection = this.selects.some((select) => select.value);
        this.button.disabled = !hasSelection;
        this.button.hidden = !hasSelection;
      }

      onAddClick() {
        const items = this.selects
          .filter((select) => select.value)
          .map((select) => {
            const option = select.options[select.selectedIndex];
            const quantity = parseInt(option.dataset.qty, 10) || 1;
            return { id: parseInt(select.value, 10), quantity };
          });

        if (!items.length || this.button.getAttribute('aria-disabled') === 'true') return;

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        if (this.spinner) this.spinner.classList.remove('hidden');
        this.setStatus('');

        const body = { items };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        fetch(`${routes.cart_add_url}`, {
          ...fetchConfig('javascript'),
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.setStatus(response.description || response.message, true);
              return;
            }

            this.setStatus('Añadido a la cesta.');

            if (this.cart) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'lamp-accessories-selector',
                cartData: response,
              });
              this.cart.renderContents(response);
            }

            this.selects.forEach((select) => {
              select.selectedIndex = 0;
            });
            this.updateButtonState();
          })
          .catch((error) => {
            console.error(error);
            this.setStatus('No se ha podido añadir. Inténtalo de nuevo.', true);
          })
          .finally(() => {
            this.button.classList.remove('loading');
            if (this.spinner) this.spinner.classList.add('hidden');
            this.button.removeAttribute('aria-disabled');
          });
      }

      setStatus(message, isError = false) {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.hidden = !message;
        this.status.classList.toggle('lamp-accessories__status--error', !!isError);
      }
    }
  );
}
